import React from 'react';
import { Star } from 'lucide-react';

const TESTIMONIALS = [
  { name: 'Moisés Anzora',  role: 'Azora Corp',                  initials: 'MA', color: 'bg-brand-600',
    quote: 'Antes tardaba horas en gestionar mis facturas. Con Facturas Simples lo hago en minutos. El módulo de compras con Gmail es increíble.' },
  { name: 'Rafael Paz',     role: 'Profesional Independiente',    initials: 'RP', color: 'bg-indigo-600',
    quote: 'La integración directa con Hacienda me da total confianza. El modo contingencia me salvó cuando el sistema de Hacienda estuvo caído.' },
  { name: 'Roberto Parras', role: 'Contador Público Certificado', initials: 'RP', color: 'bg-brand-700',
    quote: 'Manejo 5 empresas desde una sola cuenta. La firma .p12 funciona perfecto y los 11 tipos de DTE están todos disponibles.' },
  { name: 'Daniel Sandoval', role: 'Taller Sandoval',             initials: 'DS', color: 'bg-emerald-600',
    quote: 'La app es muy fácil de usar. En poco tiempo ya estaba emitiendo facturas sin complicaciones.' },
];

export default function Testimonials() {
  return (
    <section className="bg-ink-50 py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center mb-14">
          <span className="inline-block text-[11px] font-semibold uppercase tracking-[0.12em] text-brand-600 mb-4">Testimonios</span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter text-ink-950 mb-4 text-balance">
            Negocios salvadoreños que ya facturan con Facturas Simples.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map(({ name, role, initials, color, quote }) => (
            <div key={name} className="bg-white rounded-2xl p-7 border border-ink-100">
              <div className="flex gap-0.5 mb-4">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} size={14} fill="#facc15" strokeWidth={0} className="text-yellow-400" />
                ))}
              </div>
              <p className="text-[14px] text-ink-700 leading-relaxed mb-5">"{quote}"</p>
              <div className="flex items-center gap-3">
                <div className={`w-9 h-9 ${color} rounded-full flex items-center justify-center text-white text-[11px] font-bold`}>
                  {initials}
                </div>
                <div>
                  <div className="font-semibold text-ink-900 text-[14px]">{name}</div>
                  <div className="text-ink-400 text-[12px]">{role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
